import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

const getDefaultSelectedBoxOffice = (state) => {
  return {
    workingDays: [],
  };
};

export default {
  state: () => ({
    selectedBoxOffice: getDefaultSelectedBoxOffice(),
    boxOffices: [],
  }),
  mutations: {
    setSelectedBoxOffice(state, boxOffice) {
      Vue.set(state, "selectedBoxOffice", boxOffice);
    },
    setBoxOffices(state, boxOffices) {
      Vue.set(state, "boxOffices", boxOffices);
    },
    setDefaultSelectedBoxOffice(state) {
      Vue.set(state, "selectedBoxOffice", getDefaultSelectedBoxOffice());
    },
    setDefaultBoxOfficeModule(state) {
      Vue.set(state, "selectedBoxOffice", getDefaultSelectedBoxOffice());
      Vue.set(state, "boxOffices", []);
    },
  },
  actions: {
    createBoxOffice: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/box-offices/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadStationNames: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/get-by-type/" + request.unitType).then((response) => {
        return response;
      });
    },

    loadBoxOffices: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/entity").then((response) => {
        return response.data;
      });
    },
    loadUsersByUnitId: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/users/unit/" + request.unitId).then((response) => {
        return response;
      });
    },
    loadPartialUnitTree: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/units/get-partial-unit-tree/" + request.unitId).then((response) => {
        return response;
      });
    },
    loadPublishedBoxOffices: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/entity/published").then((response) => {
        return response.data;
      });
    },
    loadBoxOffice: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/entity/" + request.id).then((response) => {
        context.commit("setSelectedBoxOffice", response.data);
      });
    },
    loadSelectedBoxOfficeHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteBoxOffice: (context, boxOffice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/box-offices/entity/" + boxOffice.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          boxOffice.intents = intents;
          boxOffice.intentId = response.data.id;
          return boxOffice;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftBoxOffice: (context, boxOffice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/box-offices/draft/" + boxOffice.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishBoxOffice: (context, boxOffice) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/publish/" + boxOffice.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectBoxOffice: (context, boxOffice) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/reject/" + boxOffice.intentId).then((response) => {
        if (boxOffice.intents[0].type === "DELETE_BOX_OFFICE") {
          boxOffice.intents = null;
          boxOffice.intentId = 0;
        } else if (boxOffice.intents[0].type === "CREATE_BOX_OFFICE") {
          boxOffice.intents[0].status = "DRAFT";
        } else if (boxOffice.intents[0].type === "UPDATE_BOX_OFFICE") {
          boxOffice.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalBoxOffice: (context, boxOffice) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/sendToApproval/" + boxOffice.intentId).then((response) => {
        if (boxOffice.intents[0].type === "CREATE_BOX_OFFICE") {
          boxOffice.intents[0].status = "WAITING_APPROVAL";
        } else if (boxOffice.intents[0].type === "UPDATE_BOX_OFFICE") {
          boxOffice.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallBoxOffice: (context, boxOffice) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/recall/" + boxOffice.intentId).then((response) => {
        helper.recallOrRejectEntity(boxOffice, "boxOffice");
        return response.data;
      });
    },
    cancelBoxOffice: (context, boxOffice) => {
      return axios.get(context.getters.getMcServiceUrl + "/box-offices/cancel/" + boxOffice.intentId).then((response) => {
        return response.data;
      });
    },
    getBoxOfficeByUnitId: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/box-offices/find-by-unitId/" + request.id, {})
        .then((response) => {
          context.commit("setSelectedBoxOffice", response.data);
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadBoxOfficesWithOpenAccountsWhichLinkedToStation: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/box-offices/open-accounts/units/" + request.unitId)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {
    getSelectedBoxOffice: (state) => {
      return state.selectedBoxOffice;
    },
    getBoxOffices: (state) => {
      return state.boxOffices;
    },
  },
};
